import { render, staticRenderFns } from "./swiper-button-secondary.vue?vue&type=template&id=2f1c3980&scoped=true&"
import script from "./swiper-button-secondary.vue?vue&type=script&lang=js&"
export * from "./swiper-button-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1c3980",
  null
  
)

export default component.exports